var _rect, _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOne(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    rx: 62.5,
    fill: "#2A1A3A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224.637 206.304V237.361H207.3V182.905H223.786V192.903H224.389C225.594 189.57 227.65 186.959 230.558 185.068C233.465 183.153 236.927 182.196 240.945 182.196C244.774 182.196 248.095 183.059 250.908 184.784C253.744 186.486 255.942 188.873 257.502 191.946C259.086 194.995 259.866 198.564 259.842 202.653V237.361H242.505V206.056C242.529 203.031 241.761 200.667 240.201 198.966C238.665 197.264 236.526 196.413 233.784 196.413C231.964 196.413 230.357 196.815 228.962 197.618C227.591 198.398 226.528 199.521 225.771 200.986C225.039 202.452 224.661 204.224 224.637 206.304ZM295.033 238.39C289.336 238.39 284.42 237.267 280.284 235.022C276.171 232.753 273.004 229.526 270.783 225.343C268.584 221.136 267.485 216.137 267.485 210.346C267.485 204.721 268.596 199.805 270.818 195.597C273.04 191.367 276.171 188.081 280.213 185.741C284.255 183.378 289.017 182.196 294.501 182.196C298.377 182.196 301.922 182.799 305.137 184.004C308.351 185.21 311.128 186.994 313.468 189.358C315.808 191.721 317.628 194.64 318.928 198.115C320.228 201.565 320.878 205.524 320.878 209.992V214.317H273.548V204.248H304.747C304.723 202.405 304.286 200.762 303.435 199.32C302.584 197.878 301.414 196.756 299.925 195.952C298.46 195.125 296.77 194.711 294.855 194.711C292.917 194.711 291.18 195.148 289.644 196.023C288.107 196.874 286.89 198.044 285.992 199.533C285.094 200.998 284.621 202.665 284.574 204.532V214.778C284.574 216.999 285.011 218.949 285.886 220.628C286.76 222.282 288.001 223.57 289.608 224.492C291.215 225.414 293.13 225.875 295.352 225.875C296.888 225.875 298.283 225.662 299.535 225.236C300.788 224.811 301.863 224.185 302.761 223.357C303.66 222.53 304.333 221.514 304.782 220.308L320.701 220.769C320.039 224.338 318.585 227.446 316.34 230.094C314.118 232.717 311.199 234.762 307.583 236.227C303.967 237.669 299.783 238.39 295.033 238.39Z",
    fill: "#348BD2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M157.308 252.671C186.552 244.564 203.686 214.285 195.58 185.041C187.473 155.798 157.194 138.663 127.95 146.77C98.7067 154.877 81.5719 185.155 89.6787 214.399C97.7856 243.643 128.064 260.777 157.308 252.671Z",
    fill: "#348BD2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3494_15274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.23 162.425V236.201H137.632V177.231H137.2L120.305 187.822V173.989L138.569 162.425H153.23Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3494_15274",
    x: 120.305,
    y: 162.425,
    width: 47.7186,
    height: 82.229,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10.5668,
    dy: 4.22672
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.11336
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3494_15274"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3494_15274",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOne);
export default __webpack_public_path__ + "static/media/One.12316ac981ebf435f8a022866d636268.svg";
export { ForwardRef as ReactComponent };